import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=dda36eb6&scoped=true&"
import script from "./Markets.vue?vue&type=script&lang=js&"
export * from "./Markets.vue?vue&type=script&lang=js&"
import style0 from "./Markets.vue?vue&type=style&index=0&id=dda36eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda36eb6",
  null
  
)

export default component.exports